import { Component, Input, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ProjectDocService } from '../../../../core/services/project-doc.service';
import { ProjectDoc } from '../../../../core/models/models';

@Component({
  selector: 'app-project-doc-preview-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './project-doc-preview-dialog.component.html',
  styleUrl: './project-doc-preview-dialog.component.scss'
})
export class ProjectDocPreviewDialogComponent implements OnInit {
  private projectDocService = inject(ProjectDocService);
  private sanitizer = inject(DomSanitizer);

  @Input({ required: true }) doc!: ProjectDoc;
  @Input({ required: true }) onClose!: () => void;

  isImage = signal(false);
  safeUrl = signal<SafeResourceUrl | null>(null);
  isLoading = signal(true);
  error = signal('');

  ngOnInit(): void {
    this.isImage.set(this.doc.contentType.startsWith('image/'));
    this.loadPreview();
  }

  loadPreview(): void {
    this.projectDocService.previewDoc(this.doc.id!).subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        this.safeUrl.set(this.sanitizer.bypassSecurityTrustResourceUrl(url));
        this.isLoading.set(false);
      },
      error: () => {
        this.error.set('Impossible de charger l\'aperçu du document.');
        this.isLoading.set(false);
      }
    });
  }

  handleClose(): void {
    if (this.safeUrl()) {
      // Clean up the object URL to avoid memory leaks
      const url = (this.safeUrl() as any).changingThisBreaksApplicationSecurity;
      if (url) URL.revokeObjectURL(url);
    }
    this.onClose();
  }
}
